var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 19.4594C15.2243 19.4594 19.4594 15.2243 19.4594 9.99999C19.4594 4.77567 15.2243 0.540527 9.99999 0.540527C4.77567 0.540527 0.540527 4.77567 0.540527 9.99999C0.540527 15.2243 4.77567 19.4594 9.99999 19.4594Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33528 8.29732C7.03258 8.29732 6.79474 8.03245 6.83258 7.72975C7.0488 5.99462 8.28123 4.8811 10.1569 4.8811C11.865 4.8811 13.2056 5.90273 13.2056 7.70813C13.2056 9.03786 12.5731 9.49732 11.9731 10.0325C11.3461 10.5622 10.8758 10.946 10.7623 11.9406C10.7353 12.2 10.5245 12.4 10.2596 12.4H9.74609C9.45961 12.4 9.22177 12.1568 9.24339 11.8649C9.31907 10.6379 9.66501 10.1135 10.3191 9.55678C10.9083 9.03786 11.4542 8.70273 11.4542 7.76759C11.4542 6.63245 10.5731 6.21624 10.0812 6.21624C9.06501 6.21624 8.52988 6.84327 8.41096 7.85408C8.38393 8.10813 8.16771 8.30272 7.91366 8.30272H7.32988L7.33528 8.29732ZM9.52447 13.3676H10.3947C10.6704 13.3676 10.8974 13.5946 10.8974 13.8703V14.6108C10.8974 14.8865 10.6704 15.1135 10.3947 15.1135H9.52447C9.2488 15.1135 9.02177 14.8865 9.02177 14.6108V13.8703C9.02177 13.5946 9.2488 13.3676 9.52447 13.3676Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcoBlue);
export default __webpack_public_path__ + "static/media/i-ico-blue.235e703baacee1b7ea784c59dd6bcc2f.svg";
export { ForwardRef as ReactComponent };